import React, { forwardRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import NativeSelect from '@core/react/shared-component/NativeSelect/View';
import TextFieldInput from '@core/react/shared-component/TextInput/View';
import Button from '@core/react/shared-component/button';
// import OnFormSubmitted from './Service';

import { __ } from '@wordpress/i18n';

const GroupedFormViewMyInput = forwardRef(
	({ onClick, locationRadius, mergedDefaultValues }, ref) => {
		// when user starts typing in location field, the radius field will show
		const [hideRadius, setHideRadius] = useState(true);

		// get default values set from query params
		const { defaultKeyword, defaultCity, defaultRadius } = mergedDefaultValues;

		const { textSearchRef, locationRef, radiusRef } = ref;

		const handleKeyPress = (event) => {
			if (event.key === 'Enter') {
				// Enter key is pressed, do something
				onClick();
			}
		};

		/**
		 * When user starts typing in location field and
		 * when there is atleast one character filled, the radius field will show
		 */
		const handleLocationFieldChange = (event) => {
			if (event.target.value.length < 1) {
				setHideRadius(true);
			} else {
				setHideRadius(false);
			}
		};

		// when default city is set, show radius field
		useEffect(() => {
			if (defaultCity && defaultCity.length > 0) {
				setHideRadius(false);
			}
		}, []);

		return (
			<form onSubmit={onClick} className='c-form-inputs'>
				<TextFieldInput
					ref={textSearchRef}
					classNames='c-form-inputs__text-search c-form-inputs__text-search--keyword'
					placeholder={__('Search for jobs', 'job')}
					onKeyDown={handleKeyPress}
					defaultValue={defaultKeyword}
				/>
				<div
					className={`c-form-inputs__location-group ${
						!hideRadius ? 'c-form-inputs__location-group--concat' : ''
					}`}
				>
					<TextFieldInput
						ref={locationRef}
						onChange={handleLocationFieldChange}
						classNames='c-form-inputs__text-search'
						placeholder={__('Location', 'job')}
						onKeyDown={handleKeyPress}
						defaultValue={defaultCity}
					/>
					<NativeSelect
						ref={radiusRef}
						options={locationRadius}
						onChange={onClick}
						placeholderText={__('Radius', 'job')}
						className={`c-form-inputs__radius ${hideRadius && 'd-none'}`}
						defaultValue={defaultRadius}
					/>
				</div>

				<Button
					onClick={onClick}
					classNames='ss-button ss-button--large ss-button--green c-form-inputs__submit-button'
				>
					{__('Find jobs', 'job')}
				</Button>
			</form>
		);
	},
);

GroupedFormViewMyInput.propTypes = {
	onClick: PropTypes.func.isRequired,
	// dispatch: PropTypes.func.isRequired,
	locationRadius: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
		}),
	).isRequired,
	mergedDefaultValues: PropTypes.shape({
		defaultKeyword: PropTypes.string,
		defaultCity: PropTypes.string,
		defaultRadius: PropTypes.string,
	}).isRequired,
};

export default GroupedFormViewMyInput;
